export default __webpack_public_path__ + "static/media/6.4bb72c7d.png";